import React, { FC } from 'react';
import { ReactComponent as GoogleLogoIcon } from '../../../../assets/images/apps/Google.svg';
import './GoogleIcon.scss';

interface GoogleIconProps {
  className: string;
  size?: string;
}

const defaultProps = {
  size: 'default',
};

export const GoogleIcon: FC<GoogleIconProps> = ({ className, size }) => {
  const getIcon = (type: string) => {
    switch (type) {
      case 'big': {
        return (
          <div className={`google-icon-container__big  ${className}`}>
            <GoogleLogoIcon className="google-icon-container__big__icon" />
          </div>
        );
      }
      default: {
        return (
          <div className={`google-icon-container__small  ${className}`}>
            <GoogleLogoIcon className="google-icon-container__small__icon" />
          </div>
        );
      }
    }
  };
  return getIcon(size || defaultProps.size);
};
GoogleIcon.defaultProps = defaultProps;
